import React from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import TiersPayantStatutBadge from '../../../components/TiersPayantStatutBadge';

const DossierInfoCard = ({dossier, customer, healthInsurance}) => (
    <Card className="mb-4">
        <Card.Body>
            <Row>
                <Col md={6}><strong>Patient :</strong> {dossier.patient}</Col>
                <Col md={6}><strong>Mutuelle :</strong> {healthInsurance.name}</Col>
                <Col md={6}><strong>N° facture :</strong> {dossier.invoiceNumber}</Col>
                <Col md={6}><strong>Date facture :</strong> {dossier.invoiceDate}</Col>
                <Col md={6}><strong>Montant :</strong> {dossier.amount} €</Col>
                <Col md={6}><strong>Statut :</strong> <TiersPayantStatutBadge status={dossier.status} /></Col>
                <Col xs={12}><small className="text-muted">{customer.name} — {customer.finessCode} — {customer.city}</small></Col>
            </Row>
        </Card.Body>
    </Card>
);

export default DossierInfoCard;
